module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/3/video-preview-1-124644f445560394230c6bde015b9641.png";